import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function Disclaimer() {
  return (
    <section data-testid="results-disclaimer" className="px-6 py-20 sm:px-10 sm:py-24">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="mx-auto max-w-3xl px-8 text-center sm:px-14"
      >
        <p className="font-helvetica text-xl font-bold tracking-tight text-[#0D0D0D] sm:text-2xl">
          Results vary from person to person.
        </p>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-[#8C8B85]">
          Factors like your niche, target audience, and number of posts per
          month all influence how fast you will grow!
        </p>
      </motion.div>
    </section>
  );
}
